import React from 'react';
import Button from '../../components/Button/Button';
import Chip from '../../components/Chip/Chip';
import type { ActiveFilter } from '../types';

interface ListViewFilterChipProps {
  filter: ActiveFilter;
  onEdit: (filter: ActiveFilter) => void;
  onRemove: (filterID: string) => void;
}

/* One active filter: the field and the values it is filtered on, with the
   buttons to edit or remove it */
const ListViewFilterChip = ({ filter, onEdit, onRemove }: ListViewFilterChipProps) => (
  <Chip dataAttributes={{ 'data-test-list-view-filter-chip': true }}>
    {/* The chip's own span is not a flex container: keep the label and
        the two icon buttons on one line ourselves */}
    <span tw="inline-flex items-center">
      <span>
        {filter.fieldName}: {filter.values.join(', ')}
      </span>
      <Button
        contentType="icon"
        icon="pencil"
        size="small"
        color="default"
        variant="text"
        onClick={() => onEdit(filter)}
        dataAttributes={{ 'data-test-list-view-filter-edit': true }}
        aria-label={i18n('Edit filter')}
      />
      <Button
        contentType="icon"
        icon="close"
        size="small"
        color="default"
        variant="text"
        onClick={() => onRemove(filter.id)}
        dataAttributes={{ 'data-test-list-view-filter-remove': true }}
        aria-label={i18n('Remove filter')}
      />
    </span>
  </Chip>
);

export default ListViewFilterChip;
